var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5294 14.4821C30.6634 14.8167 29.7298 15.0366 28.7626 15.1418C29.7523 14.6351 30.5172 13.832 30.8771 12.8664C29.9435 13.3444 28.9088 13.6791 27.8178 13.8703C26.9293 13.0481 25.6808 12.5701 24.2636 12.5701C21.6205 12.5701 19.461 14.4056 19.461 16.6714C19.461 16.9965 19.506 17.3119 19.5848 17.6083C15.5807 17.4362 12.0153 15.8014 9.64211 13.3253C9.22596 13.9276 8.98977 14.6351 8.98977 15.3808C8.98977 16.8053 9.83331 18.0672 11.138 18.7842C10.3394 18.7842 9.59712 18.593 8.94478 18.3062V18.3349C8.94478 20.3234 10.6094 21.9869 12.8139 22.3597C12.1061 22.5244 11.3631 22.5473 10.6431 22.4267C10.9486 23.2417 11.5469 23.9548 12.3539 24.4658C13.1608 24.9768 14.1359 25.26 15.1421 25.2756C13.4365 26.4233 11.3225 27.0436 9.14723 27.0347C8.76482 27.0347 8.38241 27.0156 8 26.9773C10.137 28.1437 12.6789 28.8225 15.4007 28.8225C24.2636 28.8225 29.1337 22.5701 29.1337 17.1494C29.1337 16.9678 29.1337 16.7957 29.1225 16.614C30.0673 16.0404 30.8771 15.3139 31.5294 14.4821Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footer-twitter.82d1a558.svg";
export { ForwardRef as ReactComponent };